import React, { useState } from "react";
import { Formik, FormikProps, Form } from "formik";
import * as Yup from "yup";
import Input from "../../../components/input/input";
import Button from "../../../components/button/button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from "date-fns/locale/es";
registerLocale("es", es);

import {
  ContactWrapper,
  ContactFromWrapper,
  InputGroup,
  DateWrapper,
} from "./style";

interface MyFormValues {
  firstName: string;
  email: string;
  message: string;
  guests: string;
  venue: string;
  partyDate: Date;
}

const SignupSchema = Yup.object().shape({
  firstName: Yup.string().required("Pon tu nombre porfavor"),
  email: Yup.string()
    .email("Corrige el email que esta mal")
    .required("Necesitamos tu email para enviarte el presupuesto"),
  guests: Yup.string().required(
    "Necesitamos el número de invitados para poder calcular tu presupuesto"
  ),
});

const Contact: React.SFC<{}> = () => {
  const [submitted, setSubmitted] = useState(false);
  const showThankYou = (
    <div>
      <br />
      <h1>Súper 👍🏻 </h1>
      <p>
        Fernando Villar te va a enviar la propuesta en breve. Cualquier consulta
        puedes llamarlo al +51971509272
      </p>
    </div>
  );
  return (
    <Formik
      initialValues={{
        "bot-field": "",
        "form-name": "Consulta de Bodas",
        firstName: "",
        email: "",
        message: "",
        guests: "",
        venue: "",
        partyDate: new Date(),
      }}
      onSubmit={(values: MyFormValues, actions: any) => {
        setTimeout(() => {
          // console.log({ values, actions });
          // alert(JSON.stringify(values, null, 2));
          setSubmitted(true);
          actions.setSubmitting(false);
        }, 700);
      }}
      validationSchema={SignupSchema}
      render={({
        handleChange,
        values,
        errors,
        setFieldValue,
        handleBlur,
        touched,
        isSubmitting,
      }: FormikProps<MyFormValues>) => (
        <>
          <Form
            name="Consulta de Bodas"
            method="post"
            action="/enviado"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
          >
            <ContactWrapper>
              <ContactFromWrapper>
                <Input type="hidden" name="bot-field" />
                <Input
                  type="hidden"
                  name="form-name"
                  value="Consulta de Bodas"
                />
                <InputGroup>
                  <Input
                    type="text"
                    name="firstName"
                    value={`${values.firstName}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Nombre"
                    notification={`${
                      errors.firstName && touched.firstName
                        ? errors.firstName
                        : ""
                    }`}
                  />
                  <Input
                    type="email"
                    name="email"
                    value={`${values.email}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Email"
                    notification={`${
                      errors.email && touched.email ? errors.email : ""
                    }`}
                  />
                </InputGroup>
                <InputGroup>
                  <Input
                    type="text"
                    name="guests"
                    value={`${values.guests}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Cantidad de Invitados"
                    notification={`${
                      errors.guests && touched.guests ? errors.guests : ""
                    }`}
                  />
                  <Input
                    type="text"
                    name="venue"
                    value={`${values.venue}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Lugar"
                    notification={`${
                      errors.venue && touched.venue ? errors.venue : ""
                    }`}
                  />
                </InputGroup>
                <DateWrapper>
                  <div>
                    <label for="partyDate">Fecha</label>
                  </div>
                  <DatePicker
                    locale="es"
                    selected={values.partyDate}
                    dateFormat="d MMMM, yyyy"
                    className="form-control"
                    name="partyDate"
                    onChange={(date) => setFieldValue("partyDate", date)}
                  />
                </DateWrapper>
                <Input
                  type="textarea"
                  name="message"
                  value={`${values.message}`}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="Observaciones"
                  notification={
                    errors.message && touched.message ? errors.message : ""
                  }
                />

                {submitted ? (
                  showThankYou
                ) : (
                  <Button
                    title="ENVIAR"
                    type="submit"
                    isLoading={isSubmitting ? true : false}
                    loader="Enviando..."
                  />
                )}
              </ContactFromWrapper>
            </ContactWrapper>
          </Form>
        </>
      )}
    />
  );
};

export default Contact;
